import React from "react";
import ReactQuill from "react-quill";
import { Button, Card, CardBody, CardHeader, Form, FormInput, ListGroup, ListGroupItem } from "shards-react";
import FormCheckbox from "../components-overview/Checkboxes";

import "react-quill/dist/quill.snow.css";
import "../../assets/quill.css";

const Symptoms = () => (
  <Card small className="mb-3">
   <CardHeader className="border-bottom">
      <h6 className="m-0">Symptoms</h6>
    </CardHeader>
    <CardBody>
      <ListGroup flush>
    <ListGroupItem className="p-1">
        
    People may be sick with the virus for 1 to 14 days before developing symptoms. The most common symptoms of coronavirus disease (COVID-19) are fever, tiredness, and dry cough. Most people (about 80%) recover from the disease without needing special treatment. More rarely, the disease can be serious and even fatal. Older people, and people with other medical conditions (such as asthma, diabetes, or heart disease), may be more vulnerable to becoming severely ill.
<br></br><br></br>
<strong>People may experience:
    <ul>
<li>cough</li>
<li>fever</li>
<li>tiredness</li>
<li>difficulty breathing (severe cases)</li>
</ul>
</strong>

<br></br>

<a href="https://www.who.int/news-room/q-a-detail/q-a-coronaviruses#:~:text=symptoms" target="_blank">
      <Button outline theme="accent" size="sm">
            <i className="material-icons">search</i> Learn more
          </Button>
          </a>
<br></br>
          <br></br>
There is no specific medicine to prevent or treat coronavirus disease (COVID-19). People may need supportive care to help them breathe. If you have mild symptoms, stay at home until you’ve recovered.
<br></br><br></br>
<strong>You can relieve your symptoms if you:
    <ul>
<li>rest and sleep</li>
<li>keep warm</li>
<li>drink plenty of liquids</li>
<li>use a room humidifier or take a hot shower to help ease a sore throat and cough</li>
</ul>
</strong>
<br></br>
If you develop a fever, cough, and have difficulty breathing, promptly seek medical care. Call in advance and tell your health provider of any recent travel or recent contact with travelers.
<br></br><br></br>
<a href="https://www.who.int/news-room/q-a-detail/q-a-coronaviruses#:~:text=protect" target="_blank">
<Button outline theme="accent" size="sm">
            <i className="material-icons">search</i> Learn more
          </Button>
          </a>
<br></br>
        
        
      </ListGroupItem>
      
      
      </ListGroup>
    </CardBody>
  </Card>
);

export default Symptoms;
